export const GST_AU_RATE = 10;
